import Grid from "@mui/material/Grid";
import {
  hasValueInErrorMessage,
  formatAmount,
} from "../../../Utility/Utilitys";
import Box from "@mui/material/Box";
import { DataGrid } from "@mui/x-data-grid";

import {
  CmpTypographyField,
  CmpDatePickerField,
  CmpSelectField,
  CmpInputField,
  CmpRadioButton,
  CmpButton,
} from "../../../Component/Common/ToolBox/ToolBox";
import { RoDCRequest } from "../../../Redux/roStore";
import { Set_DCRequest_HeadObject_WHLoc } from "../SliceDCRequest";
import { useDispatch } from "react-redux";
import { useSelector } from "react-redux";
import GCToggleSearch from "../../../Component/Common/ReuseableComponent/GCToggleSearch";

import useMediaQuery from "@mui/material/useMediaQuery";
import { Set_DCRequest_HeadObject } from "../SliceDCRequest";
import { CmpDatePickerField001V1, CmpInputFieldGroupV1, CmpSelectFieldV1, CmpTextFieldV1 } from "../../../Component/Common/ToolBox/ToolBoxV1";
import GCToggleSearchV1 from "../../../Component/Common/ReuseableComponent/GCToggleSearchV1";
const fDummyHeadObject = () => {
  let { HeadObject } = RoDCRequest();
  return HeadObject;
};
export default function GCHead({
  HeadObject = fDummyHeadObject(),
  Grid_Head_Columns = [],
  sDocumentTypeData = [],
  sLoactionData = [],
  sDCLoactionData = [],

  fDocumentType,
  fDocumentNo,
  fDocumentDate,
  fLocation,
  fCrLimitAmt,
  fOsAmt,
  fMainGroup,
  fSubGroup,
  fGroup,
  fBrand,
  fConsumption,
  fCNSM_From_DT,
  fCNSM_To_Dt,
  fLeadDays,
  fDCLoaction,
  fPromoCode,
  fRelease_Load,
  fGC_Search_Modal,
  xErrorMsg,
}) {
  let xMdlabel = 0;
  let xMdInput = 12;
  let xSmlabel = 4;
  let xSmInput = 6;

  const vMediaQuery = useMediaQuery("(max-width:450px)");
  const WHLoc = useSelector(
    (state) => state.SliceDCRequest.value.HeadObject.WHLoc
  );
  const dispatch = useDispatch();

  const handleSelectionChange = (params) => {
    let modifiedSelect = WHLoc.map((el) => {
      if (params.includes(el.UId)) {
        return { ...el, L_Chk: "Y" };
      } else {
        return { ...el, L_Chk: "N" };
      }
    });
    console.log(modifiedSelect);
    dispatch(Set_DCRequest_HeadObject_WHLoc(modifiedSelect));
  };

  // const hasSelectedRows = WHLoc.some((row) => row.L_Chk == "Y");

  return (
    <form id="WmsDCRequestHead">
      <Grid
        container
        rowSpacing={0.9}
        columnSpacing={0.9}
        columns={{ xs: 12, sm: 12, md: 12, lg: 12 }}
      >
        <Grid item xs={12} sm={12} md={3} lg={3}>
          <Grid
            container
            spacing={0.9}
            columns={{ xs: 12, sm: 12, md: 12 }}
            className={
              hasValueInErrorMessage(xErrorMsg)
                ? "align-items-center"
                : "align-items-start"
            }
          >
             
            <Grid item xs={xSmInput} sm={xSmInput} md={xMdInput}  >
              <CmpSelectFieldV1
                xtabIndex={"1"}
                xLabelText="Doc.Typ"
                xValue={HeadObject.A_VocTyp}
                xOnChange={(e) => {
                  fDocumentType(e.target.value);
                }}
                xName={"A_VocTyp"}
                xData={sDocumentTypeData}
                xValueMember={""}
                xDispalyMember={""}
                xError={xErrorMsg.A_VocTyp === "" ? false : true}
                xErrorMessage={xErrorMsg.A_VocTyp}
                xDisable={HeadObject.A_VocNo !=0} 
                // xOnKeyUp={xKeyIInboundGrn}
              />
            </Grid>
             
            <Grid item xs={xSmInput} sm={xSmInput} md={xMdInput}  >
              <CmpInputFieldGroupV1
              xLabelText="Doc.No"
                xValue={HeadObject.A_VocNo}
                xType={"text"} // text/number/password
                xName={"A_VocNo"}
                xReadOnly={true}
                xOnChange={(e) => {
                  fDocumentNo(e.target.value);
                }}
                xError={xErrorMsg.A_VocNo === "" ? false : true}
                xErrorMessage={xErrorMsg.A_VocNo}
              />
            </Grid>
             
            <Grid item xs={xSmInput} sm={xSmInput} md={6} >
              <CmpDatePickerField001V1
              xLabelText="Doc.Date"
                xtabIndex={"2"}
                xValue={HeadObject.A_VocDt}
                xOnChange={(e) => {
                  fDocumentDate(e?.$d);
                }}
                xName={"A_VocDt"}
                xError={xErrorMsg.A_VocDt === "" ? false : true}
                xErrorMessage={xErrorMsg.A_VocDt}
              />
            </Grid>
            
            <Grid item xs={xSmInput} sm={xSmInput} md={6}  >
              <CmpSelectFieldV1
                xtabIndex={"1"}
                xLabelText="Location"
                xValue={HeadObject.A_Loc}
                xOnChange={(e) => {
                  fLocation(e);
                }}
                xName={"A_Loc"}
                xData={sLoactionData}
                xValueMember={""}
                xDispalyMember={""}
                xError={xErrorMsg.A_Loc === "" ? false : true}
                xErrorMessage={xErrorMsg.A_Loc}
                xDisable={false}
                // xOnKeyUp={xKeyIInboundGrn}
              />
            </Grid>
             
            <Grid item xs={xSmInput} sm={xSmInput} md={6}  >
            <CmpTextFieldV1
                              xLabelText="Cr.Limit.Amt"
                xValue={formatAmount(HeadObject.A_CrLimit)}
                xType={"text"} // text/number/password
                xName={"A_CrLimit"}
                xReadOnly={true}
                xOnChange={(e) => {
                  fCrLimitAmt(e.target.value);
                }}
                xError={xErrorMsg.A_CrLimit === "" ? false : true}
                xErrorMessage={xErrorMsg.A_CrLimit}
              />
            </Grid>
            
            <Grid item xs={xSmInput} sm={xSmInput} md={6}  >
             <CmpTextFieldV1
                  xLabelText="O/s Amount"
                xValue={formatAmount(HeadObject.A_OsAmt)}
                xType={"text"} // text/number/password
                xName={"A_OsAmt"}
                xReadOnly={true}
                xOnChange={(e) => {
                  fOsAmt(e.target.value);
                }}
                xError={xErrorMsg.A_OsAmt === "" ? false : true}
                xErrorMessage={xErrorMsg.A_OsAmt}
              />
            </Grid>
          </Grid>
        </Grid>
        <Grid item xs={12} sm={12} md={3} >
          <div
            style={{
              height: vMediaQuery ? "30vh" : "25vh",
              width: "100%",
            }}
          >
            <Box sx={{ height: "100%", width: "100%" }}>
              <DataGrid
                getRowClassName={(params) =>
                  params.indexRelativeToCurrentPage % 2 === 0
                    ? "mui-even-row"
                    : "mui-odd-row"
                }
                sx={{
                  border: 1,
                  borderColor: "primary.light",
                }}
                rowHeight={30}
                headerHeight={40}
                hideFooter={true}
                getRowId={(row) => row?.UId}
                rows={WHLoc}
                columns={Grid_Head_Columns}
                checkboxSelection
                onSelectionModelChange={handleSelectionChange}
                selectionModel={WHLoc.filter((row) => row.L_Chk === "Y").map(
                  (row) => row.UId
                )}
              />
            </Box>
          </div>
        </Grid>
        <Grid item xs={12} sm={12} md={3} lg={3}>
          <Grid
            container
            spacing={0.9}
            columns={{ xs: 12, sm: 12, md: 12 }}
            className={
              hasValueInErrorMessage(xErrorMsg)
                ? "align-items-center"
                : "align-items-start"
            }
          >
             
            <Grid item xs={3} sm={3} md={3} >
              <CmpTextFieldV1
                  xLabelText="Main Group"
                xValue={HeadObject.A_MainGrp}
                xType={"text"} // text/number/password
                xName={"A_MainGrp"}
                xReadOnly={true}
                xError={xErrorMsg.A_MainGrp === "" ? false : true}
                xErrorMessage={xErrorMsg.A_MainGrp}
              />
            </Grid>
            <Grid item xs={9} sm={9} md={9}>
              <GCToggleSearchV1
                                xLabelText="Main Group Name"
                xtabIndex={"17"}
                xName={"MainGrpName"}
                xType={"text"}
                xValue={HeadObject.MainGrpName}
                xReadOnly={false}
                xOnChange={(e) => {
                  fMainGroup(e.target.value);
                }}
                xOnKeyUp={(e) => {
                  if (e.key === "Enter" || e._reactName === "onClick") {
                    fGC_Search_Modal(
                      HeadObject.MainGrpName,
                      "MainGroup",
                      "Y",
                      "",
                      "",
                      "",
                      ""
                    );
                  }
                  if (e.key === "Backspace") {
                    dispatch(
                      Set_DCRequest_HeadObject({
                        ...HeadObject,
                        A_MainGrp: "",
                      })
                    );
                  }
                }}
                xError={xErrorMsg.MainGrpName === "" ? false : true}
                xErrorMessage={xErrorMsg.MainGrpName}
                xMediaQuery={false}
                xonClickbtn={(e) => {
                  if (e.key === "Enter" || e._reactName === "onClick") {
                    fGC_Search_Modal(
                      HeadObject.MainGrpName,
                      "MainGroup",
                      "Y",
                      "",
                      "",
                      "",
                      ""
                    );
                  }
                }}
              />
            </Grid>
             
            <Grid item xs={3} sm={3} md={3} lg={3}>
              <CmpTextFieldV1
                  xLabelText="Sub Group"
                xValue={HeadObject.A_SubGrp}
                xType={"text"} // text/number/password
                xName={"A_SubGrp"}
                xReadOnly={true}
                xError={xErrorMsg.A_SubGrp === "" ? false : true}
                xErrorMessage={xErrorMsg.A_SubGrp}
              />
            </Grid>
            <Grid item xs={9} sm={9} md={9}>
              <GCToggleSearchV1
              xLabelText="SubGrpName"
                xtabIndex={"17"}
                xName={"SubGrpName"}
                xType={"text"}
                xValue={HeadObject.SubGrpName}
                xReadOnly={false}
                xOnChange={(e) => {
                  fSubGroup(e.target.value);
                }}
                xOnKeyUp={(e) => {
                  if (e.key === "Enter" || e._reactName === "onClick") {
                    fGC_Search_Modal(
                      HeadObject.SubGrpName,
                      "SubGroup",
                      "Y",
                      HeadObject.A_MainGrp,
                      "",
                      "",
                      ""
                    );
                  }
                  if (e.key === "Backspace") {
                    dispatch(
                      Set_DCRequest_HeadObject({
                        ...HeadObject,
                        A_SubGrp: "",
                      })
                    );
                  }
                }}
                xError={xErrorMsg.SubGrpName === "" ? false : true}
                xErrorMessage={xErrorMsg.SubGrpName}
                xMediaQuery={false}
                xonClickbtn={(e) => {
                  if (e.key === "Enter" || e._reactName === "onClick") {
                    fGC_Search_Modal(
                      HeadObject.SubGrpName,
                      "SubGroup",
                      "Y",
                      HeadObject.A_MainGrp,
                      "",
                      "",
                      ""
                    );
                  }
                }}
              />
              {/* <CmpInputField
                xValue={HeadObject.SubGrpName}
                xType={"text"} // text/number/password
                xName={"SubGrpName"}
                xReadOnly={false}                
                xError={xErrorMsg.A_VocTyp === "" ? false : true}
                xErrorMessage={xErrorMsg.A_VocTyp}
              /> */}
            </Grid>
           

            <Grid item xs={3} sm={3} md={3} lg={3}>
                <CmpTextFieldV1
                  xLabelText="Group"
                xValue={HeadObject.A_Grp}
                xType={"text"} // text/number/password
                xName={"A_Grp"}
                xReadOnly={true}
                xError={xErrorMsg.A_Grp === "" ? false : true}
                xErrorMessage={xErrorMsg.A_Grp}
              />
            </Grid>
            <Grid item xs={9} sm={9} md={9}>
              <GCToggleSearchV1
              xLabelText="GrpName"
                xtabIndex={"17"}
                xName={"GrpName"}
                xType={"text"}
                xValue={HeadObject.GrpName}
                xReadOnly={false}
                xOnChange={(e) => {
                  fGroup(e.target.value);
                }}
                xOnKeyUp={(e) => {
                  if (e.key === "Enter" || e._reactName === "onClick") {
                    fGC_Search_Modal(
                      HeadObject.GrpName,
                      "Group",
                      "Y",
                      HeadObject.A_SubGrp,
                      "",
                      "",
                      ""
                    );
                  }
                  if (e.key === "Backspace") {
                    dispatch(
                      Set_DCRequest_HeadObject({
                        ...HeadObject,
                        A_Grp: "",
                      })
                    );
                  }
                }}
                xError={xErrorMsg.GrpName === "" ? false : true}
                xErrorMessage={xErrorMsg.GrpName}
                xMediaQuery={false}
                xonClickbtn={(e) => {
                  if (e.key === "Enter" || e._reactName === "onClick") {
                    fGC_Search_Modal(
                      HeadObject.GrpName,
                      "Group",
                      "Y",
                      HeadObject.A_SubGrp,
                      "",
                      "",
                      ""
                    );
                  }
                }}
              />
            </Grid>
            
            <Grid item xs={3} sm={3} md={3} lg={3}>
              <CmpTextFieldV1
                  xLabelText="Brand"
                xValue={HeadObject.A_Brand}
                xType={"text"} // text/number/password
                xName={"A_Brand"}
                xReadOnly={true}
                xError={xErrorMsg.A_Brand === "" ? false : true}
                xErrorMessage={xErrorMsg.A_Brand}
              />
            </Grid>
            <Grid item xs={9} sm={9} md={9}>
              <GCToggleSearchV1
              xLabelText="BrandName"
                xtabIndex={"17"}
                xName={"BrandName"}
                xType={"text"}
                xValue={HeadObject.BrandName}
                xReadOnly={false}
                xOnChange={(e) => {
                  fBrand(e.target.value);
                }}
                xOnKeyUp={(e) => {
                  if (e.key === "Enter" || e._reactName === "onClick") {
                    fGC_Search_Modal(
                      HeadObject.BrandName,
                      "Brand",
                      "Y",
                      "",
                      "",
                      "",
                      ""
                    );
                  }
                  if (e.key === "Backspace") {
                    dispatch(
                      Set_DCRequest_HeadObject({
                        ...HeadObject,
                        A_Brand: "",
                      })
                    );
                  }
                }}
                xError={xErrorMsg.BrandName === "" ? false : true}
                xErrorMessage={xErrorMsg.BrandName}
                xMediaQuery={false}
                xonClickbtn={(e) => {
                  if (e.key === "Enter" || e._reactName === "onClick") {
                    fGC_Search_Modal(
                      HeadObject.BrandName,
                      "Brand",
                      "Y",
                      "",
                      "",
                      "",
                      ""
                    );
                  }
                }}
              />
            </Grid>
          
           
          </Grid>
        </Grid>
        <Grid item xs={12} sm={12} md={3} lg={3}>
          <Grid
            container
            spacing={0.9}
            columns={{ xs: 12, sm: 12, md: 12 }}
            className={
              hasValueInErrorMessage(xErrorMsg)
                ? "align-items-center"
                : "align-items-start"
            }
          >
              <Grid item xs={xSmlabel} sm={xSmlabel} md={4}  >
              <CmpTypographyField xcomponent={"span"} xText={"Consumption"} />
            </Grid>
            <Grid item xs={8} sm={8} md={8}  >
              <Grid container    spacing={0} columns={{ xs: 12, sm: 12, md: 12, lg: 12 }}>
                <Grid item xs={6} sm={6} md={6} >
                  <CmpRadioButton
                    value="Regular"
                    label="Regular"
                    checked={HeadObject.A_CNSM_Type === "Regular"}
                    onChange={(e) => {
                      fConsumption(e.target.value);
                    }}
                  />
                </Grid>
                <Grid item xs={6} sm={6} md={6}  >
                  <CmpRadioButton
                    value="Period"
                    label="Period"
                    checked={HeadObject.A_CNSM_Type === "Period"}
                    onChange={(e) => {
                      fConsumption(e.target.value);
                    }}
                  />
                </Grid>
              </Grid>
            </Grid>
             
            <Grid item xs={12} sm={8} md={xMdInput}  >
              <Grid container columns={{ xs: 12, sm: 12, md: 12, lg: 12 }}>
                <Grid
                  item
                  xs={6}
                  sm={6}
                  md={6}
                  
                  className={
                    HeadObject.A_CNSM_Type === "Period"
                      ? ""
                      : "hide-radio-buttonStockReport"
                  }
                >
                  <CmpDatePickerField001V1
                  xLabelText="CNSM_From"
                    xtabIndex={"2"}
                    xValue={HeadObject.A_CNSM_From}
                    xOnChange={(e) => {
                      fCNSM_From_DT(e?.$d);
                    }}
                    xName={"A_CNSM_From"}
                    xError={xErrorMsg.A_CNSM_From === "" ? false : true}
                    xErrorMessage={xErrorMsg.A_CNSM_From}
                    xmaxdate={HeadObject.A_CNSM_To}
                  />
                </Grid>
                <Grid
                  item
                  xs={6}
                  sm={6}
                  md={6}
                  
                  className={
                    HeadObject.A_CNSM_Type === "Period"
                      ? ""
                      : "hide-radio-buttonStockReport"
                  }
                >
                   <CmpDatePickerField001V1
                  xLabelText="CNSM_To"
                    xtabIndex={"2"}
                    xValue={HeadObject.A_CNSM_To}
                    xOnChange={(e) => {
                      fCNSM_To_Dt(e?.$d);
                    }}
                    xName={"A_CNSM_To"}
                    xError={xErrorMsg.A_CNSM_To === "" ? false : true}
                    xErrorMessage={xErrorMsg.A_CNSM_To}
                  />
                </Grid>
              </Grid>
            </Grid>
            <Grid item xs={xSmInput} sm={4} md={6}  >
              <CmpTextFieldV1
                xLabelText="Lead Day"
                xValue={HeadObject.A_LeadDays}
                xType={"number"} // text/number/password
                xName={"A_LeadDays"}
                xReadOnly={false}
                xOnChange={(e) => {
                  fLeadDays(e.target.value);
                }}
                xError={xErrorMsg.A_LeadDays === "" ? false : true}
                xErrorMessage={xErrorMsg.A_LeadDays}
              />
            </Grid>
             
            <Grid item xs={xSmInput} sm={4} md={6}  >
              <CmpSelectFieldV1
                xtabIndex={"1"}
                xLabelText="DC Loaction"
                xValue={HeadObject.A_DCLoc}
                xOnChange={(e) => {
                  fDCLoaction(e.target.value);
                }}
                xName={"A_DCLoc"}
                xData={sDCLoactionData}
                xValueMember={""}
                xDispalyMember={""}
                xError={xErrorMsg.A_DCLoc === "" ? false : true}
                xErrorMessage={xErrorMsg.A_DCLoc}
                xDisable={false}
                // xOnKeyUp={xKeyIInboundGrn}
              />
            </Grid> 
            <Grid item xs={6} sm={4} md={6}  >
            <CmpTextFieldV1
                xLabelText="Promo Code"
                xValue={HeadObject.PrmCd}
                xType={"number"} // text/number/password
                xName={"PrmCd"}
                xReadOnly={false}
                xOnChange={(e) => {
                  fPromoCode(e.target.value);
                }}
                xError={xErrorMsg.PrmCd === "" ? false : true}
                xErrorMessage={xErrorMsg.PrmCd}
              />
            </Grid> 
            <Grid
              item
              xs={5}
              sm={4}
              md={6}
               
              className={"text-center "}
            >
              <CmpButton
                xbtnName="Release/Load"
                xOnClick={fRelease_Load}
                xVariant="contained"
                xDisabled={false}
                xSize="small"
                xjustifyContent="flex-start"
              />
            </Grid>
          </Grid>
        </Grid>
      </Grid>
    </form>
  );
}
